import dynamic from 'next/dynamic'

export const DynamicProductPageLatestActivityRecommendation = dynamic(
  async () =>
    import('./ProductPageLatestActivityRecommendation').then(
      (mod) => mod.ProductPageLatestActivityRecommendation,
    ),
  {
    ssr: false,
  },
)
